import { RootState } from 'store';
import { TIsLoading } from 'common/types/common';

import { STATE } from '../types/state';

const selector = (state: RootState): TIsLoading => {
  const { orderFirstStep: { isLoading } } = state[STATE];
  return isLoading;
};

export default selector;
